import { Create, Form, Input, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import useMediaScreen from "hooks/useMediaScreen";
import "react-mde/lib/styles/css/react-mde-all.css";
import { IGenre } from "types/genre.interface";

export const GenreCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, formLoading } = useForm<IGenre>();
  const { isMobile } = useMediaScreen();

  return (
    <Create saveButtonProps={saveButtonProps} isLoading={formLoading}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Name is required",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row" }}>
          <Form.Item
            label="Color"
            name="color"
            rules={[
              {
                required: false,
              },
            ]}
            initialValue="#000000"
            style={{ width: isMobile ? "100%" : "30%", marginRight: "40%" }}
          >
            <Input type="color" />
          </Form.Item>
          <Form.Item
            label="BgColor"
            name="bgColor"
            rules={[
              {
                required: false,
              },
            ]}
            initialValue="#000000"
            style={{ width: isMobile ? "100%" : "30%" }}
          >
            <Input type="color" />
          </Form.Item>
        </div>
      </Form>
    </Create>
  );
};
